import { Protocol } from './index';
import { Category } from '../constants';

const wallet: Protocol[] = [
  {
    name: 'Ambire Wallet',
    url: 'https://www.ambire.com/',
    logoPath: '/logos/ambire_wallet.jpg',
    category: Category.Wallet,
    twitterUrl: 'https://twitter.com/AmbireWallet',
  },
  {
    name: 'Brave',
    url: 'https://brave.com/',
    logoPath: '/logos/brave.jpg',
    category: Category.Wallet,
    twitterUrl: 'https://twitter.com/brave',
  },
  {
    name: 'Desig',
    url: 'https://desig.io/',
    logoPath: '/logos/desig.jpg',
    category: Category.Wallet,
    twitterUrl: 'https://twitter.com/DesigLabs',
  },
  {
    name: 'Frame',
    url: 'https://frame.sh/',
    logoPath: '/logos/frame.jpg',
    category: Category.Wallet,
    twitterUrl: 'https://twitter.com/0xFrame',
  },
  {
    name: 'Rabby Wallet',
    url: 'https://rabby.io/',
    logoPath: '/logos/rabby_wallet.jpg',
    category: Category.Wallet,
    twitterUrl: 'https://twitter.com/Rabby_io',
  },
  {
    name: 'Rainbow Wallet',
    url: 'https://rainbow.me/',
    logoPath: '/logos/rainbow_wallet.jpg',
    category: Category.Wallet,
    twitterUrl: 'https://twitter.com/rainbowdotme',
  },
  {
    name: 'Tokenpocket',
    url: 'https://www.tokenpocket.pro/',
    logoPath: '/logos/tokenpocket.jpg',
    category: Category.Wallet,
    twitterUrl: 'https://twitter.com/TokenPocket_TP',
  },
  {
    name: 'Trust Wallet',
    url: 'https://trustwallet.com/',
    logoPath: '/logos/trust_wallet.jpg',
    category: Category.Wallet,
    twitterUrl: 'https://twitter.com/trustwallet',
  },
];
export { wallet };
